import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-x3" }
const _hoisted_2 = { class: "mb-x3" }
const _hoisted_3 = { class: "w-1/3 mb-x1" }
const _hoisted_4 = { class: "w-1/4 mb-x1" }
const _hoisted_5 = { class: "w-1/5 mb-x1" }
const _hoisted_6 = { class: "w-1/3" }

import CheckoutSkeletonLine from '@/storecontext/shared/checkout/ui/CheckoutSkeletonLine.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutPickAndPackParcelShopSkeleton',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(CheckoutSkeletonLine)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(CheckoutSkeletonLine)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(CheckoutSkeletonLine)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(CheckoutSkeletonLine, { class: "mb-x1" }),
      _createVNode(CheckoutSkeletonLine, { class: "mb-x1" }),
      _createVNode(CheckoutSkeletonLine, { class: "mb-x1" }),
      _createVNode(CheckoutSkeletonLine, { class: "mb-x1" }),
      _createVNode(CheckoutSkeletonLine, { class: "mb-x1" })
    ])
  ]))
}
}

})